var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu-opt-dialog"},[_c('header',[_vm._v("提示")]),_vm._m(0),_c('footer',[_c('div',{staticClass:"btn left",on:{"click":_vm.toTel}},[_vm._v("电话客服")]),_c('div',{staticClass:"btn right",on:{"click":_vm.toConsult}},[_vm._v("在线客服(推荐)")])]),_c('div',{staticClass:"close",on:{"click":_vm.close}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("请您选择咨询方式")])])
}]

export { render, staticRenderFns }